import React from 'react';

const Mentions = () => {
  return (
    <div className="min-h-screen bg-white dark:bg-gray-900">
      <div className="container max-w-4xl mx-auto px-4 py-8">
        {/* Header */}
        <h1 className="text-4xl font-bold mb-4 text-gray-900 dark:text-white">Mentions Légales</h1>

        <p className="text-sm text-gray-500 dark:text-gray-400 mb-8">
          Dernière mise à jour : {new Date().toLocaleDateString('fr-FR')}
        </p>

        {/* Éditeur du site */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Éditeur du site
          </h2>
          <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg space-y-2 text-gray-700 dark:text-gray-300">
            <p>
              <strong>Nom :</strong> Alcantara Rémi, EI
            </p>
            <p>
              <strong>Forme juridique :</strong> Entreprise Individuelle (EI)
            </p>
            <p>
              <strong>SIRET :</strong> 53169357000040
            </p>
            <p>
              <strong>Siège social :</strong> 173 rue de Courcelles, 75017 Paris, France
            </p>
            <p>
              <strong>Email :</strong> contact@remadia.com
            </p>
            <p>
              <strong>Téléphone :</strong> N/A
            </p>
            <p>
              <strong>Directeur de publication :</strong> Rémi Alcantara
            </p>
          </div>
        </section>

        {/* Hébergement */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Hébergement de l'application
          </h2>
          <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg space-y-2 text-gray-700 dark:text-gray-300">
            <p className="font-semibold mb-2">Le site est hébergé par :</p>
            <p>
              <strong>Google Ireland Limited</strong> (Firebase Hosting)
            </p>
            <p>Gordon House, Barrow Street</p>
            <p>Dublin 4, Irlande</p>
            <p>
              Site web :{' '}
              <a
                href="https://firebase.google.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 dark:text-blue-400 underline"
              >
                firebase.google.com
              </a>
            </p>
          </div>
        </section>

        {/* Hébergement des données */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Hébergement des données utilisateurs
          </h2>
          <div className="bg-gray-50 dark:bg-gray-800 p-6 rounded-lg space-y-2 text-gray-700 dark:text-gray-300">
            <p className="font-semibold mb-2">Les données utilisateurs sont hébergées sur :</p>
            <p>
              <strong>Firebase (Google Cloud Platform)</strong>
            </p>
            <p>Google Ireland Limited</p>
            <p>Gordon House, Barrow Street</p>
            <p>Dublin 4, Irlande</p>
          </div>
        </section>

        {/* Propriété intellectuelle */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Propriété intellectuelle
          </h2>
          <p className="leading-relaxed text-gray-700 dark:text-gray-300 mb-4">
            L'ensemble du contenu de ce site (textes, images, vidéos, logos, design, structure) est
            protégé par le droit d'auteur et appartient à Remadia Health ou à ses partenaires.
          </p>
          <p className="leading-relaxed text-gray-700 dark:text-gray-300">
            Toute reproduction, distribution, modification, adaptation, retransmission ou
            publication, même partielle, de ces différents éléments est strictement interdite sans
            l'accord exprès par écrit de l'éditeur.
          </p>
        </section>

        {/* Limitation de responsabilité */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Limitation de responsabilité
          </h2>
          <div className="space-y-4 text-gray-700 dark:text-gray-300">
            <p className="leading-relaxed">
              L'éditeur s'efforce d'assurer au mieux de ses possibilités l'exactitude et la mise à
              jour des informations diffusées sur ce site. Toutefois, il ne peut garantir
              l'exactitude, la précision ou l'exhaustivité des informations mises à disposition.
            </p>
            <p className="leading-relaxed">L'éditeur ne saurait être tenu responsable :</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>
                Des erreurs, omissions ou résultats pouvant être obtenus par un mauvais usage du
                service
              </li>
              <li>De l'interprétation des informations contenues dans ce site</li>
              <li>De tout dysfonctionnement du réseau ou des serveurs</li>
              <li>De tout dommage direct ou indirect résultant de l'utilisation du site</li>
            </ul>
          </div>
        </section>

        {/* Liens hypertextes */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Liens hypertextes
          </h2>
          <p className="leading-relaxed text-gray-700 dark:text-gray-300">
            Le site peut contenir des liens vers des sites externes. L'éditeur ne peut être tenu
            responsable du contenu de ces sites externes et décline toute responsabilité quant à
            leur contenu et leur fonctionnement.
          </p>
        </section>

        {/* Droit applicable */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">
            Droit applicable
          </h2>
          <p className="leading-relaxed text-gray-700 dark:text-gray-300">
            Les présentes mentions légales sont soumises au droit français. En cas de litige et à
            défaut d'accord amiable, le litige sera porté devant les tribunaux français conformément
            aux règles de compétence en vigueur.
          </p>
        </section>

        {/* Contact */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">Contact</h2>
          <div className="bg-blue-50 dark:bg-blue-900/20 p-6 rounded-lg text-gray-700 dark:text-gray-300">
            <p className="mb-2">Pour toute question concernant le site ou vos données :</p>
            <p>
              <strong>Email :</strong> contact@remadia.com
            </p>
            <p>
              <strong>Adresse postale :</strong> 173 rue de Courcelles, 75017 Paris, France
            </p>
          </div>
        </section>

        {/* Crédits */}
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800 dark:text-gray-200">Crédits</h2>
          <div className="text-gray-700 dark:text-gray-300 space-y-2">
            <p>
              <strong>Conception et développement :</strong> Rémi Alcantara
            </p>
            <p>
              <strong>Technologies utilisées :</strong>
            </p>
            <ul className="list-disc list-inside ml-4 space-y-1">
              <li>React.js</li>
              <li>Firebase (Hosting, Firestore, Auth, Cloud Functions)</li>
              <li>OpenAI API</li>
              <li>Stripe</li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Mentions;